import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IPayerMasterItem } from '../Infrastructure/Interfaces';
import { AppDispatch } from '../Store/StoreInit';
import PayerMasterPg from './PayerMasterPg';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';
  
interface RootState {  
  payerMasterList: {  
    payerMasterList: IPayerMasterItem[];  
    loading: boolean;  
  };  
}  
  
const PayerMaster: React.FC = () => {  
  const { payerMasterList, loading } = useSelector((state: RootState) => state.payerMasterList);  
  const dispatch = useDispatch<AppDispatch>();  
  
  useEffect(() => {  
    dispatch(fetchPayerMasterList());  
  }, [dispatch]);  
  
  if (loading) {  
    return (  
      <div className="contentDiv">  
        <h3>Loading...</h3>  
      </div>  
    );  
  }  
  
  if (!payerMasterList) {  
    return <h3>Data not found...</h3>;  
  }  
  
  return <PayerMasterPg payerMasterLists={payerMasterList} />;  
}  
  
export default PayerMaster;  
